angular.module('impactx.catalog').controller('CatalogRuleCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$mdToast',
    'ConfirmationService',
    '$securityManager',
    'ToolbarService',
    'LoadingDialogService',
    CatalogRuleCtrl
]);

function CatalogRuleCtrl($scope, dataGen, $routeParams, BackService, $mdToast, ConfirmationService, $securityManager, ToolbarService, LoadingDialogService) {

    $scope.requestInProgress = false;
    
    var self = this;

    if ($routeParams.catId > 0) {
        dataGen.getData($scope, {
            id: $routeParams.id,
            catId: $routeParams.catId
        }, "/catalog/ruledetailforcat").then(function () {
            defineButtons();
        });
    }
    else {
        dataGen.getData($scope, {id: $routeParams.id}, "/catalog/rule/system/edit").then(function () {
            defineButtons();
        });
    }

    self.selectCheckTemplate = function () {
        var tempScope = {};
        dataGen.getData(tempScope, {templateId: $scope.data.checkRulePopup.selected, catId: $routeParams.catId},
            "/catalog/ruletemplatedataforcat").then(function () {
            $scope.data.setItem = tempScope.data;
        });
    };

    self.selectQueryTemplate = function () {
        var tempScope = {};
        dataGen.getData(tempScope, {templateId: $scope.data.queryRulePopup.selected, catId: $routeParams.catId},
            "/catalog/ruletemplatedataforcat").then(function () {
            $scope.data.setItem = tempScope.data;
        });
    };

    self.selectStatisticTemplate = function () {
        var tempScope = {};
        dataGen.getData(tempScope, {templateId: $scope.data.statisticRulePopup.selected, catId: $routeParams.catId},
            "/catalog/ruletemplatedataforcat").then(function () {
            $scope.data.setItem = tempScope.data;
        });
    };

    self.selectImportTemplate = function () {
        var tempScope = {};
        dataGen.getData(tempScope, {templateId: $scope.data.importRulePopup.selected, catId: $routeParams.catId},
            "/catalog/ruletemplatedataforcat").then(function () {
            $scope.data.setItem = tempScope.data;
        });
    };

    self.selectChangeTemplate = function () {
        var tempScope = {};
        dataGen.getData(tempScope, {templateId: $scope.data.changeRulePopup.selected, catId: $routeParams.catId},
            "/catalog/ruletemplatedataforcat").then(function () {
            $scope.data.setItem = tempScope.data;
        });
    };

    self.save = function () {
        $scope.requestInProgress = true;
        LoadingDialogService.start();
        var dataObj = {
            rule: $scope.data.setItem
        };
        var endpoint = "/catalog/saveruledetailforcat";
        if ($routeParams.catId == 0) {
            endpoint = "/catalog/rule/system/save"
        }
        return dataGen.postAsForm({}, dataObj, endpoint).then(function () {
            $scope.requestInProgress = false;
            LoadingDialogService.stop();
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.saveSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        }, function () {
            $scope.requestInProgress = false;
            LoadingDialogService.stop();
        });
    };

    self.toggleStatus = function () {
        var dataObj = {
            cmriId: $scope.data.setItem.id
        };
        var tempScope = {};
        return dataGen.postAsForm(tempScope, dataObj, "/catalog/togglerulestatusforcat").then(function () {
            $scope.data.setItem.statusString.value = tempScope.trns.newStatus;
            $scope.data.setItem.status = $scope.data.setItem.status == 1 ? 2 : 1;
            $mdToast.show(
                $mdToast.simple()
                    .textContent(tempScope.trns.activateMessage)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    self.addField = function (fields, label) {
        fields.push({label: label});
    };

    self.removeField = function (fields, index) {
        fields.splice(index, 1);
    };

    self.canDeleteRule = function () {
        return $scope.data && $scope.data.setItem && $scope.data.setItem.id > 0 && !$scope.data.readOnly && $securityManager.isProcessAllowed("CatalogRuleDelete");
    };

    self.deleteDialog = function (event) {
        ConfirmationService.showConfirmationDialog(self.delete, event, $scope.trns.confirmDelete,
            $scope.trns.delete, $scope.trns.abort);
    };

    self.delete = function () {
        var dataObj = {
            id: $routeParams.id
        };
        return dataGen.getData($scope, dataObj, "/catalog/rule/delete").then(function () {
            BackService.back();
            $mdToast.show(
                $mdToast.simple()
                    .textContent($scope.trns.deleteSuccess)
                    .position("bottom right")
                    .hideDelay(10000)
            );
        });
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.activate,
                action: self.toggleStatus,
                type: 'dialogaction',
                condition: canActivate
            },
            {
                label: $scope.trns.deactivate,
                action: self.toggleStatus,
                type: 'dialogaction',
                condition: canDeactivate
            },
            {
                label: $scope.trns.delete,
                action: self.deleteDialog,
                type: 'dialogaction',
                condition: canDelete
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly && !$scope.requestInProgress;
    }

    function canActivate() {
        var data = $scope.data;
        return data.setItem && data.setItem.id > 0 && !data.readOnly && data.setItem.status == 2 && !data.isDeprecated;
    }

    function canDeactivate() {
        var data = $scope.data;
        return data.setItem && data.setItem.id > 0 && !data.readOnly && data.setItem.status == 1 && !data.isDeprecated;
    }

    function canDelete() {
        return self.canDeleteRule() && !$scope.data.isDeprecated;
    }
}